import RootLayout from '../Layout';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
import startLottie from '../../const/lottie/start.json';
import home0 from '../../const/lottie/home0.json';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import useInitImg from '../../hooks/useInitImg';
import Img from '../Img';
import useScreenWidthBelowThreshold from '../../hooks/useScreenWidthBelowThreshold';
import OneLinkImg from '../OneLinkImg';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../stores/AuthContext';
import HomeMobile from './mobile';
import MatchmakingEntry from './MatchmakingEntry';
import { backgroundArr, backgroundArrMobile, TitleColorMap, titleArr } from './const';
import { useStores } from '../../stores/storeContext';
import WingLoginModal from '../playgroundMobile/localPlayground/WingLoginModal';
import { isWingLocalLoggedIn } from '../playgroundMobile/localPlayground/storage';

export default function Home({ onIndexChange, isWing }) {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(1281);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showStartLottie, setShowStartLottie] = useState(true);
  const [showInitialTitle, setShowInitialTitle] = useState(false);
  const [showNormalTitle, setShowNormalTitle] = useState(false);
  const [showWingLogin, setShowWingLogin] = useState(false);
  const [wingLogged, setWingLogged] = useState(false);
  const router = useRouter();
  const { t } = useTranslation();
  const { logged } = useAuth();
  const { rootStore } = useStores();

  useEffect(() => {
    if (isWing) {
      setWingLogged(isWingLocalLoggedIn());
    }
  }, [isWing, showWingLogin]);

  useEffect(() => {
    if (router.query?.ref === 'producthunt') {
      // 把后缀干掉并且打一个点
      router.push('/');
      fetch('/web/event?event_name=producthunt_website_visits');
    }
  }, [router, router.query]);

  useEffect(() => {
    onIndexChange(activeIndex);
  }, [activeIndex, onIndexChange]);

  useInitImg([...backgroundArr, ...backgroundArrMobile]);

  useEffect(() => {
    if (showNormalTitle || isScreenWidthBelow700px) {
      const interval = setInterval(() => {
        if (isScreenWidthBelow700px) {
          setActiveIndex((index) => (index + 1) % backgroundArrMobile.length);
        } else {
          setActiveIndex((index) => (index + 1) % backgroundArr.length);
        }
      }, 9000);
      return () => clearInterval(interval);
    }
  }, [showNormalTitle, isScreenWidthBelow700px]);

  const handleLoginClick = () => {
    if (isWing) {
      if (isWingLocalLoggedIn()) {
        router.push('/playground_mobile');
      } else {
        setShowWingLogin(true);
      }
      return;
    }
    if (logged) {
      router.push('/playground_mobile');
    } else {
      rootStore.setCurModal('login');
    }
  };

  if (isScreenWidthBelow700px) {
    // 手机端
    return (
      <>
        <HomeMobile
          props={{
            logged,
            activeIndex,
            TitleColorMap,
            backgroundArrMobile,
            isWing,
            onLoginClick: handleLoginClick,
          }}
        />
        {showWingLogin ? (
          <WingLoginModal
            onClose={() => setShowWingLogin(false)}
            onSuccess={() => {
              setShowWingLogin(false);
              router.push('/playground_mobile');
            }}
          />
        ) : null}
      </>
    );
  }
  // pc端
  return (
    <RootLayout className={styles.wrapper} style={{ backgroundImage: `url(${backgroundArr[activeIndex]})` }}>
      <>
        {showStartLottie && (
          <div
            className={styles.start}
            style={{ position: 'fixed', inset: 0, zIndex: 100, backgroundColor: '#fff' }}
          >
            <Lottie
              animationData={startLottie}
              className={styles.startAnim}
              onComplete={() => {
                setShowStartLottie(false);
                setShowInitialTitle(true);
                setTimeout(() => {
                  setShowInitialTitle(false);
                  setShowNormalTitle(true);
                }, 2500);
              }}
              loop={false}
            />
          </div>
        )}
        <div className={styles.logo}>
          <div className={styles.loginButton} onClick={handleLoginClick}>
            {isWing ? (wingLogged ? 'Play' : 'Login') : logged ? 'Play' : 'Login'}
          </div>
          <div className={styles.brandRow}>
            <Img
              className={styles.duetLogo}
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjRVM0haNTdUU0ZBVzdLQldLVjJWSTRRVTdQREgzRyIsInciOjIxNiwiaCI6NjQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDI1NTY2MTc3NTgzNDU2MzN9"
            />
            {!isWing && <MatchmakingEntry />}
          </div>
        </div>
        {showInitialTitle && <Lottie className={styles.title} animationData={home0} />}
        {showNormalTitle && <Lottie className={styles.title} animationData={titleArr[activeIndex]} />}
        <div className={styles.content}>
          <a
            href="https://duet.onelink.me/GBnZ/t3682sma"
            target="_blank"
            className={styles.one}
            rel="noreferrer"
            suppressHydrationWarning
          />
          <div className={styles.two}>GET THE APP</div>
          <div className={styles.three}>
            <OneLinkImg src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlhJRTYzRTVEQkhaNjVSUllDNEJFM0NCWlc1Qk1ZVSIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo3NTUzNTQ5MTM3MDEzMjk5Mn0" />
            <a href="https://play.google.com/store/apps/details?id=next.bondee.tech" target="_blank" rel="noreferrer">
              <Img src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlNEUDI1SFJXQjI3UUtMRVBTWU83RExGVkk0RkFXNiIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoyNTk2MzI3MTE0MDIzMDY1Nn0" />
            </a>
          </div>
        </div>
        {showWingLogin ? (
          <WingLoginModal
            onClose={() => setShowWingLogin(false)}
            onSuccess={() => {
              setShowWingLogin(false);
              router.push('/playground_mobile');
            }}
          />
        ) : null}
      </>
    </RootLayout>
  );
}
